import type { Custody } from '@infinex/types';

import type { AccountAddress } from '../../../types';
import type { ChainAssetBalance } from '../balance';

export function addUniqueCustodyAddresses(
  existingCustody: Custody[],
  newBalance: Pick<ChainAssetBalance, 'chain' | 'walletAddress'>,
  accountAddresses: AccountAddress[]
): Custody[] {
  const newCustody = accountAddresses.find(
    (a) =>
      a.chain === newBalance.chain && a.address === newBalance.walletAddress
  )?.custody;

  if (!newCustody) {
    return existingCustody;
  }

  return existingCustody.includes(newCustody)
    ? existingCustody
    : [...existingCustody, newCustody];
}
